import { func, number } from 'prop-types';
import React from 'react';

function PageNavButtons({ curPage, totalPages, paginateUser }) {
    return (
        <div>
            {curPage > 0 ? (
                <button
                    onClick={() => paginateUser(curPage - 1)}
                    className={'custom-btn me-1'}
                >
                    Back
                </button>
            ) : null}
            {curPage < totalPages ? (
                <button
                    className={'custom-btn'}
                    onClick={() => paginateUser(curPage + 1)}
                >
                Next
                </button>
            ) : null}
        </div>
    );
}

PageNavButtons.propTypes = {
    curPage: number,
    totalPages: number,
    paginateUser: func,
};

export default PageNavButtons;